<template>
  <va-card>
    <div class="row col-12 d-flex justify--space-between">
      <h5 class="is-bold">{{ measurementTitle }}</h5>
      <font-awesome-icon
        icon="fa-solid fa-down-left-and-up-right-to-center"
        class="clickable card-icon"
        @click.prevent="$emit('collapse')"
      />
    </div>
      <div class="row col-12">
        <div class="col-3 col-md-3 col-sm-3 mt-5 p-0">
          <div class="h-100 d-flex flex-column">
            <div style="flex: 0 0 80%" class="d-flex justify--center align-items-center">
              <div class="d-flex flex-column">
                <div class="d-flex justify--center p-0" style="min-width: 72px">
                  <span :class="icon"/>
                </div>
                <div class="text-center mt-3">
                <span class="is-bold mt-3 text-center" v-if="data && data.length && data[0].isIndividualResult === true">
                  {{data[0].lastResults[0]}}
                </span>
                  <span class="is-bold mt-3 text-center" v-else-if="data && data.length && data[0].isIndividualResult === false && data[0].lastResults.length > 0">
                  {{data[0].lastResults[0]}}
                  <va-popover
                    placement="top">
                    <template #popover>
                      <ul style="margin: 0; padding-left: 1em;">
                        <li v-for="elem in data[0].lastResults">{{elem}}</li>
                      </ul>
                    </template>
                    <i class="fa fa-plus-circle"></i>
                  </va-popover>
                </span>
                  <span class="is-bold mt-3 text-center" v-else>
                  N/A
                </span>
                </div>
              </div>
            </div>
            <div class="text-center" style="flex: 0 0 10%">
              <label style="font-size: 12.5px"
                     :class="{'recent-update': hasBeenUpdatedRecently}">{{ $t('dashboard_new_evollu.titles.last_update') }}: {{ lastUpdate || "N/A" }} </label>
            </div>


          </div>

        </div>
        <div class="col-9 col-md-9 col-sm-9">
          <div>
            <va-tabs v-model="tabValue" style="border-width: 2px" :disabled="true">
              <va-tab
                v-for="tab in viewType"
                :key="tab"
              >
                {{ $t(`dashboard_new_evollu.parameters.titles.${tab}`)}}
              </va-tab>
            </va-tabs>
            <v-client-table
              v-if="tabValue === 0"
              id="dataTable"
              ref="dataTable"
              name="dataTable"
              :data="data"
              :columns="columns"
              :options="tableOptions"
              @row-click="showAudiogramGraph"
            >
              <span slot="created_at" slot-scope="{row}">
                {{row.created_at}}
              </span>
              <span slot="automatic" slot-scope="{row}" class="d-flex">
                <va-popover
                  v-if="row.automatic !== null && row.automatic === true"
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.device')">
                  <i class="fa fa-tablet"/>
                </va-popover>
                <va-popover
                  v-else
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submitted_by.manual')">
                  <i class="fa fa-pencil"/>
                </va-popover>
                <va-popover
                  v-if="row.appointmentId !== null"
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submited_at.checkup_app')">
                  <i class="i-checkup-logo-dark-gray ml-2" style="height: 16px; width: 16px"/>
                </va-popover>
                <va-popover
                  v-else
                  placement="top"
                  :message="$t('checkup_plus.person.measurements.submited_at.home')">
                  <i class="fa fa-house ml-2"/>
                </va-popover>

              </span>
            </v-client-table>

            <div v-if="tabValue===1">
              <HearingTest
                v-if="hearingTestData"
                class="mt-4"
                :hideTitle="true"
                :show-average="true"
                :ht="hearingTestData"/>
            </div>
          </div>
        </div>
      </div>
  </va-card>
</template>

<script>
import { ClientTable } from 'vue-tables-2'
import Vue from "vue";
import HearingTest from "@/components/common/HearingTest";
import moment from "moment/moment";
Vue.use(ClientTable, {}, false, 'bootstrap4')
export default {
  components: {
    HearingTest,
    ClientTable,
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    measurementTitle: {
      type: String,
      required: true
    },
    lastUpdate: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
  },
  data: function () {
    return {
      tabValue: 0,
      viewType: ['table', 'graph'],
      hearingTestData: null,
      tableOptions: {
        sortable: [],
        filterable: false,
        headings: {
          created_at: this.$t('tables.columns.created_at'),
          notes: this.$t('dashboard_new_evollu.parameters.titles.notes'),
          systolic: this.$t('dashboard_new_evollu.measurement_types.systolic_short'),
          diastolic: this.$t('dashboard_new_evollu.measurement_types.diastolic_short'),
          heart_rate: this.$t('dashboard_new_evollu.measurement_types.heart_rate_short'),
          duration_session: this.$t('dashboard_new_evollu.measurement_types.duration_session_short'),
          oximetry_max: this.$t('dashboard_new_evollu.measurement_types.oximetry_max_short'),
          oximetry_min: this.$t('dashboard_new_evollu.measurement_types.oximetry_min_short'),
          oximetry_avg: this.$t('dashboard_new_evollu.measurement_types.oximetry_avg_short'),
          pulse_rate_max: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_max_short'),
          pulse_rate_min: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_min_short'),
          pulse_rate_avg: this.$t('dashboard_new_evollu.measurement_types.pulse_rate_avg_short'),
          body_temperature: this.$t('dashboard_new_evollu.measurement_types.body_temperature'),
          forced_expiratory_volume_6_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_6_sec_short'),
          forced_expiratory_volume_1_sec: this.$t('dashboard_new_evollu.measurement_types.forced_expiratory_volume_1_sec_short'),
          fev1_fev6: this.$t('dashboard_new_evollu.measurement_types.fev1_fev6_short'),
          forced_mid_expiratory_flow_25_75: this.$t('dashboard_new_evollu.measurement_types.forced_mid_expiratory_flow_25_75_short'),
          body_weight: this.$t('dashboard_new_evollu.measurement_types.body_weight_short'),
          body_mass_index: this.$t('dashboard_new_evollu.measurement_types.body_mass_index_short'),
          body_water_percentage: this.$t('dashboard_new_evollu.measurement_types.body_water_percentage_short'),
          body_fat_percentage: this.$t('dashboard_new_evollu.measurement_types.body_fat_percentage_short'),
          body_muscle_mass: this.$t('dashboard_new_evollu.measurement_types.body_muscle_mass_short'),
          frailty_accessment_result: this.$t('dashboard_new_evollu.measurement_types.frailty_accessment_result_short'),
          frailty_exhaustion_result: this.$t('dashboard_new_evollu.measurement_types.frailty_exhaustion_result_short'),
          frailty_physical_activity: this.$t('dashboard_new_evollu.measurement_types.frailty_physical_activity_short'),
          frailty_walk_time: this.$t('dashboard_new_evollu.measurement_types.frailty_walk_time_short'),
          frailty_dominant_strength: this.$t('dashboard_new_evollu.measurement_types.frailty_dominant_strength_short'),
          frailty_weight_loss: this.$t('dashboard_new_evollu.measurement_types.frailty_weight_loss_short'),
          sarc_f: this.$t('dashboard_new_evollu.measurement_types.sarc_f_short'),
          hand_grip: this.$t('dashboard_new_evollu.measurement_types.hand_grip_short'),
          gait_speed: this.$t('dashboard_new_evollu.measurement_types.gait_speed_short'),
          sarc_result: this.$t('dashboard_new_evollu.measurement_types.sarc_result_short'),
          fasting: this.$t('dashboard_new_evollu.measurement_types.fasting_short'),
          blood_glucose: this.$t('dashboard_new_evollu.measurement_types.blood_glucose_short'),
          actions: this.$t('tables.columns.actions'),
          hl_left: this.$t('dashboard_new_evollu.measurement_types.hl_left'),
          hl_right: this.$t('dashboard_new_evollu.measurement_types.hl_right'),
          hl: this.$t('dashboard_new_evollu.measurement_types.hl_result'),
          automatic: this.$t('checkup_plus.person.measurements.automatic')
        },
        skin: 'table table-striped table-hover is-fullwidth',
        perPage: 5,
        perPageValues: [5, 10, 15, 20, 30, 50, 100],
        pagination: {
          chunk: 5,
          nav: 'scroll'
        },
        columnsClasses: {
          actions: 'actions',
          automatic: 'actions'
        }
      },
    }
  },
  created() {
    this.hearingTestData = {
      hl_left: this.data[0].hl_left,
      hl_right: this.data[0].hl_right,
      hl_result: this.data[0].hl_raw,
      result: this.data[0].result_graph_str
    }
  },
  computed: {
    hasBeenUpdatedRecently: function () {
      if (this.lastUpdate !== null) {
        return moment().diff(moment(this.lastUpdate), 'hours') < 12
      }
      return false
    },
  },
  methods: {
    showAudiogramGraph: function ({row}) {
      this.hearingTestData = {
        hl_left: row.hl_left,
        hl_right: row.hl_right,
        hl_result: row.hl_raw,
        result: row.result_graph_str
      }
      this.tabValue = 1
    }
  }
}
</script>
<style scoped lang="scss">
.chart{
  canvas{
    width:1000px !important;
    height:600px !important;
  }
}

.chart-wrapper {
  width: 100%;
  height: 400px;
  margin-top: 1rem;
  margin-bottom: 0.4rem;
  margin-right: 7.5%;
}

.icon-last-measurement {
  height: 80%;
  display: flex;
  flex-direction: column;
}

.card-icon {
  color: $vue-green;
  font-size: 22px;
}
</style>
<style lang="scss">
.actions {
  text-align: center;
}
</style>
